import { useState, useMemo, useEffect } from 'react';

type CheckboxGroupOptions = {
  [key: string]: boolean;
};

export function useCheckboxGroup(initialValues: CheckboxGroupOptions) {
  // 选中状态管理
  const [selectedValues, setSelectedValues] = useState<CheckboxGroupOptions>(initialValues);

  // 全选状态计算
  const isAllSelected = useMemo(() => {
    const values = Object.values(selectedValues);
    return values.length > 0 && values.every(v => v);
  }, [selectedValues]);

  // 半选状态计算
  const isIndeterminate = useMemo(() => {
    const values = Object.values(selectedValues);
    const checkedCount = values.filter(v => v).length;
    return checkedCount > 0 && checkedCount < values.length;
  }, [selectedValues]);

  // 处理全选切换
  const handleSelectAll = (checked: boolean) => {
    const newValues = { ...selectedValues };
    Object.keys(newValues).forEach(key => {
      newValues[key] = checked;
    });
    setSelectedValues(newValues);
  };

  // 处理单个选项切换
  const handleSelectChange = (key: string, checked: boolean) => {
    setSelectedValues(prev => ({
      ...prev,
      [key]: checked
    }));
  };

  return {
    selectedValues,
    isAllSelected,
    isIndeterminate,
    handleSelectAll,
    handleSelectChange,
    setSelectedValues // 暴露完整的setter方法，方便特殊场景使用
  };
}

// 单个复选框状态管理
export function useSelectSend(
  checked: boolean = false,
  selectChange: (type: string, checked: boolean) => void,
  type: string
) {
  const [checkboxChecked, setCheckboxChecked] = useState(checked);

  useEffect(() => {
    setCheckboxChecked(checked);
  }, [checked]);

  const handleCheckboxChange = (checked: boolean) => {
    setCheckboxChecked(checked);
    selectChange?.(type, checked);
  };

  return {
    checkboxChecked,
    setCheckboxChecked,
    handleCheckboxChange
  };
}
